import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { TiVoDeviceClientType } from "./types";

export const useUpdateClientType = (
  platformId?: string,
  oemId?: string,
  clientTypeId?: string
) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<
    ApiResponse<TiVoDeviceClientType>,
    Error,
    Partial<TiVoDeviceClientType>
  >({
    mutationFn: async (data) =>
      dispatch(
        apiThatThrows.updateTiVoClientType.action({
          params: { oemId, platformId, clientTypeId },
          options: {
            body: JSON.stringify({
              data: {
                type: "TiVoDeviceClientType",
                attributes: data,
              },
            }),
          },
        })
      ),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["platforms"],
        }),
        queryClient.invalidateQueries({
          queryKey: ["oem", platformId, oemId],
        }),
        queryClient.invalidateQueries({
          queryKey: ["clientType", platformId, oemId, clientTypeId],
        }),
      ]);
    },
  });
};
